import * as FeatherIcons from 'vue-feather-icons';

export default {
    items: [
        {
            name: 'Dashboard',
            type: 'dashboard',
            route: 'dashboard',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.GridIcon,
        },
        {
            name: 'Content',
            children: [
                // { name: 'Layouts', route: 'layouts' },
                { name: 'Pages', route: 'pages', type: 'page' },
                { name: 'Panel library', route: 'panels', type: 'panel' },
                // { name: 'Quick Links', route: 'quick_links', type: 'quick_link' },
            ],
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.LayersIcon,
        },
        {
            name: 'Assets',
            route: 'assets/0',
            type: 'asset',
            color: 'navy',
            group: 'general',
            iconComponent: FeatherIcons.ImageIcon,
        },
        {
            name: 'News',
            route: 'news_posts',
            type: 'news_post',
            // children: [
            //     { name: 'Posts', route: 'news_posts', type: 'news_post' },
            //     { name: 'Categories', route: 'news_categories', type: 'news_category' },
            // ],
            color: 'navy',
            group: 'media',
            iconComponent: FeatherIcons.FileTextIcon,
        },
        {
            name: 'Technical Hub',
            children: [
                { name: 'Resources', route: 'resources', type: 'resource' },
                { name: 'Categories', route: 'resource_categories', type: 'resource_category' },
            ],
            // iconName: '',
            color: 'navy',
            group: 'media',
            iconComponent: FeatherIcons.ImageIcon,
        },
        // {
        //     name: 'Events',
        //     children: [
        //         { name: 'Events', route: 'events', type: 'event' },
        //         { name: 'Categories', route: 'event_categories', type: 'event_category' },
        //     ],
        //     // iconName: '',
        //     color: 'navy',
        //     group: 'media',
        //     iconComponent: FeatherIcons.CalendarIcon,
        // },
        // {
        //     name: 'Banners',
        //     route: 'banners',
        //     type: 'banner',
        //     iconClass: 'kt-menu__link-icon flaticon2-chat-2',
        //     // iconName: '',
        //     color: 'navy',
        //     group: 'media',
        //     iconComponent: FeatherIcons.MessageSquareIcon,
        // },

        {
            name: 'Hybrids',
            children: [
                { name: 'Maize Silage', route: 'silage_hybrids', type: 'silage_hybrid', _shortcut: 'silage_hybrid/_' },
                { name: 'Maize Grain', route: 'grain_hybrids', type: 'grain_hybrid', _shortcut: 'grain_hybrid/_' },
                { name: 'Silage HPI', route: 'silage_hybrid_comparisons', type: 'silage_hybrid_comparison', _shortcut: 'silage_hybrid_comparison/_' },
                { name: 'Grain HPI', route: 'grain_hybrid_comparisons', type: 'grain_hybrid_comparison', _shortcut: 'grain_hybrid_comparison/_' },
            ],
            group:'Products',
            iconComponent: FeatherIcons.BoxIcon,
            color: 'navy',
        },

        {
            name: 'Regions',
            children: [
                { name: 'Hybrid Regions', route: 'hybrid_regions', type: 'hybrid_region' },
                { name: 'Comparison Regions', route: 'comparison_regions', type: 'comparison_region' },
            ],
            group:'Products',
            iconComponent: FeatherIcons.MapPinIcon,
            color: 'navy',
        },

        {
            name: 'Events',
            route: 'events',
            type: 'events',
            group:'Events',
            iconComponent: FeatherIcons.CalendarIcon,
            color: 'navy',
        },
        {
            name: 'Attendees',
            route: 'event_attendees',
            type: 'event_attendees',
            group:'Events',
            iconComponent: FeatherIcons.UsersIcon,
            color: 'navy',
        },

        {
            name: 'Team',
            children: [
                { name: 'Team Members', route: 'team_members', type: 'team_member' },
                { name: 'Regions', route: 'team_categories', type: 'team_category' },
            ],
            color: 'navy',
            group: 'team',
            iconComponent: FeatherIcons.SmileIcon,
        },

        {
            name: 'Locations',
            route: 'locations',
            type: 'location',
            color: 'navy',
            group: 'locations',
            iconComponent: FeatherIcons.MapIcon,
        },
        // {
        //     name: 'Customers',
        //     ...{ name: 'Customers', route: 'customers', type: 'customer' },
        //     // iconName: '',
        //     color: 'navy',
        //     group: 'client',
        //     iconComponent: FeatherIcons.UsersIcon,
        // },
        {
            name: 'Enquiries',
            route: 'enquiries',
            type: 'enquiry',
            // children: [
            //     { name: 'Enquiries', route: 'enquiries', type: 'enquiry' },
            //     { name: 'Subscribers', route: 'subscribers', type: 'subscriber' },
            // ],
            color: 'navy',
            group: 'client',
            iconComponent: FeatherIcons.MailIcon,
        },
        {
            name: 'Calculator Results',
            route: 'calculator_results',
            type: 'calculator_result',
            color: 'navy',
            group: 'client',
            iconComponent: FeatherIcons.ActivityIcon,
        },
        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users' },
                { name: 'Roles', route: 'roles' },
            ],
            color: 'navy',
            group: 'settings',
            iconComponent: FeatherIcons.LockIcon,
        },
        {
            name: 'Settings',
            children: [
                { name: 'Settings', route: 'settings', type: 'setting' },
                { name: 'Redirect URLs', route: 'redirect_urls', type: 'redirect_url' },
                { name: 'Offer Modals', route: 'offers', type: 'offer' },
            ],
            // iconName: '',
            color: 'navy',
            group: 'settings',
            iconComponent: FeatherIcons.SettingsIcon,
        }
    ],
    defaultItem: 'Content',
}
